import React,{ useState } from 'react';

const TeeCard = (props)=> {
    const { book, onBookSelect, isBookingAllowed } = props;

    const [isClicked, setIsClicked] = useState(false);

     const handleClick = async () => {
        if (isClicked) return; //block double click

        setIsClicked(true);
        try {
            await onBookSelect(book); // if async
        } finally {
            setTimeout(()=>{
                setIsClicked(false); // reset after 200ms
            }, 200)
        }
    };

    return(<>
        <div  className="col-md-6 col-sm-6 col-lg-3 padding-0" >            
            <div className={`slot-card ${ ((!!book.Status && book.Status != 'Cancelled') || (isBookingAllowed) ) && 'disableClick'}`} 
                onClick={handleClick} 
                // onClick={() => onBookSelect(book)} 
            >
                <div className={`${ 
                    (!book.Status) ? 'slot-card-header': 
                    (book.Status == 'Pending') ? 'slot-card-header-pending': 
                    (book.Status == 'Cancelled') ? 'slot-card-header-cancel' : 
                    (book.Status == 'FCFS') ? 'slot-card-header-fcfs' : 
                    'slot-card-header-blur' 
                }`}> 
                    <div className="row margin-0">
                        <div className="col-xs-12 padding-0">
                            <b> {book.Slot} </b>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
}


export default TeeCard;